import React, { Component } from "react";
import { Link } from "react-router-dom";
// import { connect } from 'react-redux';
// import { history } from '../../_helpers';
import AMLogo from '../assets/images/audition-magic-favicon.png';



class CheckinSuccess extends Component {
	state = {
		path: '/artist/login'
	}
	componentWillMount() {
		const { location } = this.props
		console.log(location)
		// if (location.state.clientDetails) {
		// 	thi.setState({
		// 		path: ''
		// 	})
		// }

	}
	render() {
		const { location } = this.props
		return (
			<div className="checkin-success">
				<section id="brand-logo" className="section-brand-logo section">
				  <div className="row">
				  <div className="small-12 small-centered column text-center">
				  	<img className="am-logo" src={ AMLogo } alt="" />
				    <p className="top-title">Audition Magic Project Client Page</p>
				  </div>
				  </div>
				</section>

				<section className="section gray-bg">
					<div className="grid-x align-center">
					<div className="small-12 medium-10 large-8 cell">

					<div className="text-center white-text">
						<h3>Success!</h3>
						<h5 className="loading-text">
						Thank you {location.state.artist.first_name}, you have successfully checked-in, you are ready to audition, good luck!
						</h5>
					</div>

					</div>
					</div>
				</section>

				<section className="section">
					<div className="grid-x align-center">
						<div className="small-6 cell text-center">
							{
								location.state && location.state.clientDetails
									? <Link
										  className="button primary"
											to={{
												pathname:`/artist/login`,
												search: `?project=${location.state.clientDetails.projectId.id}`,
												state: location.state.clientDetails }}>
											Return to Login Page
										</Link>
									: <Link className="button primary next" to="/artist/login">Return to Login Page</Link>
							}
						</div>
					</div>
				</section>
			</div>
		)
	}
}


export default CheckinSuccess



// WEBPACK FOOTER //
// ./src/components/CheckinSuccess.js